__turbopack_context__.v({
  "inheritTabColor": "ShimmerTabLabel-module__J45Jwa__inheritTabColor",
  "restingLabel": "ShimmerTabLabel-module__J45Jwa__restingLabel",
  "shimmerLabel": "ShimmerTabLabel-module__J45Jwa__shimmerLabel",
});
